/* LAMORE Edit — effects: announcement rotator, word reveals, image wipes,
   parallax, scroll-reactive marquee, hero autoplay, button roll. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;

  function onView(els, cb, margin) {
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(cb); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); } });
    }, { rootMargin: margin || '0px 0px -10% 0px', threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAnnounce() {
    document.querySelectorAll('[data-la]').forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var msgs = root.querySelectorAll('.la__msg');
      if (msgs.length < 2 || reduce) return;
      var i = 0, paused = false;
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        var cur = msgs[i]; i = (i + 1) % msgs.length; var nxt = msgs[i];
        cur.classList.remove('is-active'); cur.classList.add('is-leaving');
        nxt.classList.remove('is-leaving'); nxt.classList.add('is-active');
        setTimeout(function () { cur.classList.remove('is-leaving'); }, 700);
      }, 4000);
    });
  }

  function splitWords() {
    var els = document.querySelectorAll('.lr-h2, .ls-h2, .lm-faq .lm-h2, .lm-details__title');
    var list = [];
    els.forEach(function (el) {
      if (el.dataset.fx || el.children.length) return;
      var text = el.textContent.trim();
      if (!text) return;
      el.dataset.fx = '1';
      el.setAttribute('aria-label', text);
      el.innerHTML = text.split(/\s+/).map(function (w, n) {
        return '<span class="fx-w" aria-hidden="true"><span style="--i:' + n + '">' + w.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span></span>';
      }).join(' ');
      el.classList.add('fx-words');
      list.push(el);
    });
    onView(list, function (el) { el.classList.add('is-in'); });
  }

  function initWipes() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.lr-card__media, .lr-feature__media, .ls-explore__stage, .ls-frame')).filter(function (el) { return !el.dataset.fx; });
    els.forEach(function (el) { el.dataset.fx = '1'; el.classList.add('fx-wipe'); });
    onView(els, function (el) { el.classList.add('is-in'); }, '0px');
    if (!reduce) document.documentElement.classList.add('fx-ready');
  }

  function initParallax() {
    if (reduce) return;
    var imgs = document.querySelectorAll('.lr-feature__media img');
    if (!imgs.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.translate = '0 ' + (p * -40).toFixed(1) + 'px';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function initMarquee() {
    if (reduce) return;
    var tracks = document.querySelectorAll('.lr-marquee__track');
    if (!tracks.length || !tracks[0].getAnimations) return;
    var last = window.scrollY, rate = 1, target = 1;
    window.addEventListener('scroll', function () {
      var d = window.scrollY - last; last = window.scrollY;
      target = Math.max(-5, Math.min(5, 1 + d * 0.12));
      if (Math.abs(target) < 1) target = d < 0 ? -1 : 1;
    }, { passive: true });
    (function loop() {
      rate += (target - rate) * 0.08;
      target += ((target < 0 ? -1 : 1) - target) * 0.04;
      tracks.forEach(function (t) { t.getAnimations().forEach(function (a) { a.playbackRate = rate; }); });
      requestAnimationFrame(loop);
    })();
  }

  function initHeroAuto() {
    document.querySelectorAll('[data-lr-slider]').forEach(function (root) {
      if (root.dataset.auto) return; root.dataset.auto = '1';
      var next = root.querySelector('[data-lr-next]');
      if (!next || reduce || design) return;
      var bar = document.createElement('div'); bar.className = 'lr-hero__bar'; bar.innerHTML = '<i></i>';
      root.appendChild(bar);
      var fill = bar.firstChild, timer, paused = false, DUR = 6000;
      function run() {
        clearTimeout(timer);
        fill.classList.remove('is-run'); void fill.offsetWidth; fill.classList.add('is-run');
        timer = setTimeout(function () { if (!paused && !document.hidden) next.click(); else run(); }, DUR);
      }
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      root.addEventListener('click', function (e) { if (e.target.closest('.lr-arrow')) run(); });
      var track = root.querySelector('[data-lr-track]');
      if (track) track.addEventListener('touchstart', function () { run(); }, { passive: true });
      run();
    });
  }

  function initRoll() {
    document.querySelectorAll('.lr-btn:not([data-lr-add]):not([type="submit"]), .lm-btn[href]').forEach(function (b) {
      if (b.dataset.roll || b.children.length) return;
      var t = b.textContent.trim(); if (!t) return;
      b.dataset.roll = '1';
      var safe = t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      b.innerHTML = '<span class="lr-roll"><span data-text="' + safe + '">' + safe + '</span></span>';
    });
  }

  function initAdded() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lr-add]');
      if (!b || b.disabled) return;
      var label = b.querySelector('[data-lr-label]');
      var original = label && label.textContent;
      var obs = new MutationObserver(function () {
        if (!b.classList.contains('is-busy') && label) {
          obs.disconnect();
          label.textContent = 'added ✓'; b.classList.add('is-added');
          setTimeout(function () { label.textContent = original; b.classList.remove('is-added'); }, 1600);
        }
      });
      obs.observe(b, { attributes: true, attributeFilter: ['class'] });
    }, true);
  }

  function init() { initAnnounce(); splitWords(); initWipes(); initRoll(); initHeroAuto(); }
  function boot() { init(); initParallax(); initMarquee(); initAdded(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', init);
})();
